import classNames from "classnames";
import { priceFormatter } from "../../../lib/utils/prices"

import styles from './PlanCard.module.css';
// TODO: Add type for plan.
export const PlanCard = ({ plan, selected, success, isInput, onClick, ...props }: any) => {
    const handleOnClick = () => {
        if (onClick) {
            onClick(plan);
        }
    }
    const handleOnChange = () => {
        onClick(plan);
    }
    return (
        <div
            key={props?.key || plan?.id}
            className={classNames({
                [styles.planCard]: true,
                [styles.planCardSelected]: selected,
                [styles.planCardSuccess]: success,
                [styles.planCardInput]: isInput,
            })}
            onClick={handleOnClick}
        >
            {isInput && (
                <input type="radio" checked={selected} onChange={handleOnChange} />
            )}
            <div className={styles.planDetail}>
                <p className={styles.mealPerWeek}>
                    <b>{plan?.mealsPerDelivery} Meals</b> / week
                </p>
                <p>
                    {priceFormatter(plan?.price / plan?.mealsPerDelivery)} per meal
                </p>
            </div>
            <div className={styles.planPrices}>
                <p className={styles.total}>
                    {priceFormatter(plan?.price)}
                </p>
                <p className='taxes'>
                    Delivery {priceFormatter(plan?.deliveryFee)} + taxes
                </p>
            </div>
        </div>
    )
};